/**
 * The intro's own preload set: `TITLE.TTM`'s ticks plus the two songs
 * `INTRO_SONG_CUES` names, through the generic `cutscenePreloadSet`
 * (`shell/cutscene/cutscene-cues.ts`, moved there so every other cutscene
 * gets the same derivation from its own ticks and songs). `palettes` is
 * dropped here rather than re-exported: `TITLE.TTM` never issues a
 * `LOAD PAL` that needs decoding (its screens and sprites already carry
 * their palette baked in — see `cutscene-stage.ts`'s header), so it would
 * always be empty and nothing downstream of `IntroPreloadSet` expects it.
 */

import { cutscenePreloadSet } from "../cutscene/cutscene-cues.ts";
import { INTRO_SONG_CUES } from "./intro-machine.ts";
import type { IntroTick } from "./intro-ticks.ts";

export interface IntroPreloadSet {
  /** Baked image ids (no `.png`) for every background and sprite sheet the script draws. */
  readonly images: readonly string[];
  /** The subset of `images` that also needs frame rectangles out of the bake manifest. */
  readonly sprites: readonly string[];
  /** `/baked` URLs for both songs and every sound-effect cue. */
  readonly audio: readonly string[];
}

const INTRO_SONGS = INTRO_SONG_CUES.map(([, song]) => song);

export function introPreloadSet(ticks: readonly IntroTick[]): IntroPreloadSet {
  const { images, sprites, audio } = cutscenePreloadSet(ticks, INTRO_SONGS);
  return { images, sprites, audio };
}
